// src/containers/MainLayout.tsx
import React, { useState, useMemo } from 'react';
import { createTheme, ThemeProvider, CssBaseline } from '@mui/material';
import NavBar from '../Components/Navbar';
import VerticalDotsNav from '../Components/VerticalDotsNav';
import HomePage from '../Components/Accueil';
import APropos from '../Components/APropos';
import CursusEtExperiences from '../Components/Cursus';
import CompetencesGridNeon from '../Components/Competences';
import QualitesGridNeon from '../Components/Qualite';
import ProjetsGridNeon from '../Components/Projets';
import ContactFooter from '../Components/Footer';

const MainLayout: React.FC = () => {
    const [mode, setMode] = useState<'light' | 'dark'>('light');
    const [language, setLanguage] = useState<'en' | 'fr'>('fr');

    const toggleTheme = () => {
        setMode(prevMode => (prevMode === 'light' ? 'dark' : 'light'));
    };

    const theme = useMemo(
        () =>
            createTheme({
                palette: {
                    mode,
                    ...(mode === 'dark'
                        ? {
                            primary: { main: '#90caf9' },
                            background: { default: '#121212', paper: '#1e1e1e' },
                            text: { primary: '#ffffff', secondary: '#b0bec5' },
                        }
                        : {
                            primary: { main: '#1976d2' },
                            background: { default: '#f5f5f5', paper: '#ffffff' },
                            text: { primary: '#000000', secondary: '#424242' },
                        }),
                },
                typography: { fontFamily: 'Roboto, sans-serif' },
            }),
        [mode]
    );

    return (
        <ThemeProvider theme={theme}>
            <CssBaseline />
            {/* Ajout d'une classe "dark" sur le conteneur global si mode sombre */}
            <div className={mode === 'dark' ? 'dark' : ''}>
                <NavBar mode={mode} toggleTheme={toggleTheme} language={language} setLanguage={setLanguage} />
                <VerticalDotsNav language={language} />
                <section id="accueil" style={{ minHeight: '100vh', paddingTop: '60px', marginBottom: '40px' }}>
                    <HomePage language={language} />
                </section>
                <section id="apropos" style={{ minHeight: '100vh', marginBottom: '50px' }}>
                    <APropos language={language} />
                </section>
                <section id="cursus" style={{ minHeight: '100vh', marginBottom: '50px' }}>
                    <CursusEtExperiences language={language} />
                </section>
                <section id="competences" style={{ minHeight: '100vh', marginBottom: '300px' }}>
                    <CompetencesGridNeon language={language} />
                </section>
                <section id="qualites" style={{ minHeight: '100vh', marginBottom: '10px' }}>
                    <QualitesGridNeon language={language} />
                </section>
                <section id="projets" style={{ minHeight: '100vh', marginBottom: '40px' }}>
                    <ProjetsGridNeon language={language} />
                </section>
                <ContactFooter language={language} />
            </div>
        </ThemeProvider>
    );
};

export default MainLayout;
